function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 18,
  width: 5,
  height: 81,
  rx: 2.5,
  fill: "#F7F7FA"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 34,
  y: 18,
  width: 5,
  height: 81,
  rx: 2.5,
  fill: "#F7F7FA"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 64,
  y: 18,
  width: 5,
  height: 81,
  rx: 2.5,
  fill: "#F7F7FA"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 94,
  y: 18,
  width: 5,
  height: 81,
  rx: 2.5,
  fill: "#F7F7FA"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 124,
  y: 18,
  width: 5,
  height: 81,
  rx: 2.5,
  fill: "#F7F7FA"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 154,
  y: 18,
  width: 5,
  height: 81,
  rx: 2.5,
  fill: "#F7F7FA"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 184,
  y: 18,
  width: 5,
  height: 81,
  rx: 2.5,
  fill: "#F7F7FA"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 214,
  y: 18,
  width: 5,
  height: 81,
  rx: 2.5,
  fill: "#F7F7FA"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M1 36L34.04 27L63.16 30.7059L93.96 27L113 28.5882",
  stroke: "#38A169",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M3 93L39.3303 73.747L73.1376 72.0482L93.3211 55.0602L113 46",
  stroke: "#008B94",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeDasharray: "5 5"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M2.5 67L32.5 62L68.5 65.5L93 74L112 71.5",
  stroke: "#666E7A",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 113,
  width: 2.5,
  height: 116,
  rx: 1.25,
  fill: "#D8D8DD"
});

function SvgGraph(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 219,
    height: 116,
    viewBox: "0 0 219 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/Graph.cc695f27.svg";
export { ForwardRef as ReactComponent };